// extracted by mini-css-extract-plugin
module.exports = {"labelName":"formproperties_labelName__3JY2j"};